var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-sections-container"},[(_vm.showMuestras)?_c('MenuMuestras',{attrs:{"menu":_vm.menu}}):_vm._e(),_vm._v(" "),(_vm.showAreas)?_c('MenuAreas',{attrs:{"menu":_vm.menu}}):_vm._e(),_vm._v(" "),(_vm.showImages)?_c('MenuImages',{attrs:{"menu":_vm.menu}}):_vm._e(),_vm._v(" "),(_vm.showBaseMap)?_c('MenuMapaBase'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }